export const environment = {
  apiBaseUrl: 'https://prototypes.cosy.bio/academate4j-api/',
  wsBaseUrl: 'wss://prototypes.cosy.bio/academate4j-ws/',
  ccUrl: 'https://prototypes.cosy.bio/academate4j/',
  stage: "staging",
  production: false
};
